import axios from "common/helpers/axios.helper"

const reportError = (error) => {

    if (error.response) {
        if (error.response.status === 400) {
            console.log('ERROR(response): status: 400 -> Session ist abgelaufen', error.response)
        } else {
            console.log('ERROR(response): Aktion konnte nicht ausgeführt werden!')
        }

    } else if (error.request) {
        console.log('ERROR(request)', error.request)
    } else {
        console.log('ERROR(request) setup?', error.message)
    }
}

export const deleteFile = (type, path, name, successCallback = null, errorCallback = null) => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ name, path, type: 'FILE_DELETE_PENDING' });

        let url = '';
        if (type === 'common' || type === 'tutorial') {
            url = apiURL + `/api/v1/file/${currentContainer}/common/${name}`;
        } else {
            url = apiURL + `/api/v1/file/${currentContainer}/${type}/${path}/${name}`;
        }

        axios({
            url: encodeURI(url),
            method: 'DELETE',
            timeout: 10 * 1000,
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            responseType: 'json'
        }).then((response) => {
            dispatch({ type: 'FILE_DELETE_SUCCESS', payload: response.data });
            successCallback && successCallback(response.data);
        }).catch((error) => {
            reportError(error)
            errorCallback && errorCallback(error)
            dispatch({ type: 'FILE_DELETE_ERROR', payload: error.response })
        });
    }
}

/**
 * Datendatei hochladen
 * 
 * Die Funktion wird verwendet, um Videos, Bilder oder PDF-Dokumente auf den Server hochzuladen.
 * 
 * Wird die Datei erfolgreich hochgeladen, so wird 'successCallback' ausgeführt.
 * Wird die Datei nicht hochgeladen werden, so wird 'errorCallback' ausgeführt.
 * Während der Übertragung wird 'progressCallback' ausgeführt, sodass der 
 * upload-Fortschritt verfolgt werden kann.
 * 
 * Die Datei muss innerhalb von 5 Minuten hochgeladen werden.
 * 
 * @param {string} type - Dateityp - 'common', 'product', 'group', etc.
 * @param {string} path - Dateipfad
 * @param {string} name - Dateiname
 * @param {byte} data - Dateidaten
 * @param {function} successCallback - call bei erfolgreichem Upload 
 * @param {function} errorCallback - call bei fehlerhaftem Upload
 * @param {function} progressCallback - calls während Upload
 *
 */
export const uploadFile = (type, path, name, data, successCallback = null, errorCallback = null, progressCallback = null) => {
    const upload_timeout = 120 * 60 * 1000; // 120 Minuten

    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        let url = '';
        if (type === 'common' || type === 'tutorial') {
            url = apiURL + `/api/v1/file/${currentContainer}/common/${name}`;
        } else {
            url = apiURL + `/api/v1/file/${currentContainer}/${type}/${path}/${name}`;
        }

        const onUploadProgress = (e) => {
            // REDUX-Store auf 'FILE_UPLOAD_PROGRESS' setzen. 
            // Gleichzeitig Upload-Fortrschritt aktualisieren.
            dispatch({ name, path, type: 'FILE_UPLOAD_PROGRESS', payload: { total: e.total, progress: e.loaded } });
            progressCallback && progressCallback(e); // Progress-Callback ausführen
        }

        const onUploadSuccess = (response) => {
            // REDUX-Store auf 'FILE_UPLOAD_SUCCESS' setzen. 
            dispatch({ name, path, type: 'FILE_UPLOAD_SUCCESS', payload: { total: null, progress: null } });
            successCallback && successCallback(response.data); // Success-Callback ausführen
        }

        const onUploadError = (error) => {
            reportError(error); // Fehler genauer anzeigen
            errorCallback && errorCallback(error); // Error-Callback ausführen
            // Falls ein Fehler auftritt oder der Timeout abgelaufen ist
            // REDUX-Store auf 'FILE_UPLOAD_ERROR' setzen 
            dispatch({ name, path, type: 'FILE_UPLOAD_ERROR', payload: { total: null, progress: null, error: error.message } });
        }

        // ==========================================================================
        // UPLOAD
        // ==========================================================================

        // START
        // Vor dem eigentlichen Upload REDUX-Store auf 'FILE_UPLOAD_PENDING' setzen. 
        dispatch({ name, path, type: 'FILE_UPLOAD_PENDING', payload: { total: 0, progress: 0 } });

        // UPLOAD
        // Upload durchführen 
        axios({
            url: encodeURI(url),
            method: 'POST',
            timeout: upload_timeout,
            headers: { 'authorization': token, 'Content-Type': 'multipart/form-data' },
            data: data,
            onUploadProgress: onUploadProgress
        }).then((response) => {
            onUploadSuccess(response);
        }).catch((error) => {
            onUploadError(error);
        });
    }
}

export const uploadFileError = (message) => {
    return (dispatch) => {
        dispatch({ type: 'FILE_UPLOAD_ERROR', payload: { total: null, progress: null, error: message } });
    }
}

export const uploadFileHidden = (hidden) => {
    return (dispatch) => {
        dispatch({ type: 'FILE_UPLOAD_HIDDEN', payload: { hidden } });
    }
}

/**
 * JSON-datei hochladen
 * 
 * Die Funktion wird verwendet, um JSON-Dokumente auf den Server hochzuladen.
 * 
 * Wird die Datei erfolgreich hochgeladen, so wird 'successCallback' ausgeführt.
 * Wird die Datei nicht hochgeladen, so wird 'errorCallback' ausgeführt.
 * Während der Übertragung wird 'progressCallback' ausgeführt, sodass der  
 * upload-Fortschritt verfolgt werden kann.
 * 
 * Die Datei muss innerhalb von 60 Sekunden hochgeladen werden.
 * 
 * @param {string} type - Dateityp - 'common', 'product', 'group', etc.
 * @param {string} path - Dateipfad
 * @param {string} name - Dateiname
 * @param {byte} data - Dateidaten
 * @param {function} successCallback - call bei erfolgreichem Upload 
 * @param {function} errorCallback - call bei fehlerhaftem Upload
 * @param {function} progressCallback - calls während Upload
 *
 */
export const uploadJSON = (path, name, data, successCallback = null, errorCallback = null, progressCallback = null) => {
    return (dispatch, getState) => {
        const { apiURL, token, currentContainer } = getState().app;

        dispatch({ type: 'FILE_UPLOAD_PENDING' });

        let url = '';
        if (path === '') {
            url = apiURL + `/api/v1/file/${currentContainer}/json/${name}`;
        } else {
            url = apiURL + `/api/v1/file/${currentContainer}/json/${path}/${name}`;
        }

        axios({
            url: encodeURI(url),
            method: 'POST',
            timeout: 60 * 1000,
            headers: { 'authorization': token, 'Content-Type': 'application/json' },
            data: data,
            onUploadProgress: progressCallback
        }).then((response) => {
            dispatch({ type: 'FILE_UPLOAD_SUCCESS', payload: response.data });
            successCallback && successCallback(response.data);
        }).catch((error) => {
            dispatch({ type: 'FILE_UPLOAD_ERROR', payload: error.response });
            errorCallback && errorCallback(error);
        });
    }
}

